module.exports = __webpack_public_path__ + "img/whats-new-1_en.fd0885f.jpg";